import FetchFactory from "vuex-fetch-factory";
import { StateInterface } from "./state";
import { ManualRaw, ManualModel } from "../models";
import { getManuals } from "../api";
import { setManualsHandle } from "./mutations";

const factory = new FetchFactory<StateInterface, unknown>();

export default {
  fetchManuals: factory.createBulkFetcher<unknown, ManualRaw, ManualModel>(
    false,
    setManualsHandle,
    getManuals,
    (): ManualModel => new ManualModel()
  ),
  forceFetchManuals: factory.createBulkFetcher<unknown, ManualRaw, ManualModel>(
    true,
    setManualsHandle,
    getManuals,
    (): ManualModel => new ManualModel()
  ),
};
